export const getLanguage = () => {
  return navigator.language;
};
